<app-widget [hideIcon]="true">
  @if(showUpgradeHeader()){
  <!--IF NOT PREMIUM (AND STATUS RESOLVED) DISPLAY ROLLABLE HEADER-->
  <ng-container [ngTemplateOutlet]="rollableWidgetTitle"></ng-container>
  } @else {
  <div class="tw-flex tw-justify-between tw-gap-2">
    <div class="tw-shrink-0">
      <ng-container [ngTemplateOutlet]="balanceTemplate"></ng-container>
    </div>
    @if (moreThanCurrentAccount() !== null) {
    <div class="tw-flex tw-items-center tw-gap-0.5 tw-min-w-0">
      <button
        type="button"
        class="tw-flex tw-items-center tw-h-full tw-text-primary tw-font-semibold tw-text-lg tw-whitespace-nowrap tw-min-w-0"
        (click)="callScenarioDifferenceDialog()"
      >
        <app-large-amount
          [fullText]="moreThanCurrentAccount() | number: '1.0-0'"
          [compactText]="moreThanCurrentAccountCompact()"
          [alignEnd]="true"
          [textClass]="'tw-text-primary tw-font-semibold tw-text-lg'"
          prefix="(+ "
          [suffix]="' ' + getCurrencyCode() + ')'"
        ></app-large-amount>
      </button>
      <button
        type="button"
        class="tw-leading-none"
        aria-hidden="true"
        tabindex="-1"
        (click)="callScenarioDifferenceDialog()"
      >
        <icon [name]="'info-tooltip'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
      </button>
    </div>
    }
  </div>
  }
  <div class="tw-flex tw-items-center sm:tw-justify-center" (click)="toggleEye()">
    <span
      class="tw-font-roboto-condensed tw-text-4xl tw-flex-1 tw-text-center"
      [ngClass]="{
        'tw-text-dt-text-in-primary': isEyeOpen() && balance() > 0.01,
        'tw-text-dt-text-secondary': !isEyeOpen() || (balance() >= -0.01 && balance() <= 0.01),
        'tw-text-dt-text-out-primary': isEyeOpen() && balance() < -0.01,
      }"
    >
      @if (isViewReady()) { @if (UseMacroNumber(balance())) { {{ balance() | macroNumber |
      asterisks}} } @else { @if (!isEyeOpen()) { {{ balance() | asterisks }} } @else {
      <span>{{ balanceParts().sign }}{{ balanceParts().integer }}</span>
      <span
        class="tw-text-[18px] tw-ml-[-7px] tw-align-baseline tw-font-medium tw-leading-[125%]"
        data-testid="balance-hud-decimals"
        >{{ balanceParts().decimals }}</span
      >
      } }
      <span class="tw-text-sm tw-text-dt-text-tertiary"> {{ getCurrencyCode() }}</span>
      } @else if (showBalanceSkeleton()) {
      <!-- Amount + currency placeholders, same style as the account-row and chart skeletons.
           h-8 stays within the text-4xl line, so the card doesn't jump when the balance lands. -->
      <!-- Decorative: the Views page announces its loading (#6305). -->
      <span
        class="tw-inline-flex tw-items-end tw-gap-2 tw-align-middle"
        aria-hidden="true"
        data-testid="balance-skeleton"
      >
        <span class="tw-h-8 tw-w-32 tw-rounded tw-bg-dt-slate-8/40 tw-animate-pulse"></span>
        <span class="tw-h-4 tw-w-10 tw-rounded tw-bg-dt-slate-8/40 tw-animate-pulse"></span>
      </span>
      }
    </span>
    <!-- A real button so the toggle is reachable with Tab and works with Enter/Space; it has no
         (click) of its own — the click bubbles to the row's toggleEye(), so it doesn't fire twice. -->
    <button
      type="button"
      class="tw-ml-2 tw-mb-2.5 sm:tw-mb-0 tw-p-0 tw-leading-none"
      [attr.aria-label]="'toggleVisibility' | i18n"
      [attr.aria-pressed]="isEyeOpen()"
    >
      <icon
        [name]="isEyeOpen() ? 'eye' : 'eye-off'"
        [size]="6"
        [currentColor]="'color-icon-default'"
        class="tw-w-5"
      ></icon>
    </button>
  </div>
</app-widget>

<!--ROLLABLE WIDGET TITLE-->
<ng-template #rollableWidgetTitle>
  <ng-container titleWidget>
    <div class="tw-overflow-hidden">
      <div
        class="tw-flex-col tw-flex tw-h-10"
        [ngClass]="{
          'tw-animate-ticker-loop': !tickerPaused,
          'tw-translate-y-[-100%] tw-[animation:none]': tickerPaused
        }"
        (mouseenter)="pauseTicker()"
        (mouseleave)="resumeTicker()"
      >
        <!-- BALANCE -->
        <ng-container [ngTemplateOutlet]="balanceTemplate"></ng-container>

        <!-- UPDATE BALANCE AUTOMATICALLY -->
        <ng-container [ngTemplateOutlet]="updateBalanceAutomaticallyTemplate"></ng-container>

        <!-- BALANCE -->
        <ng-container [ngTemplateOutlet]="balanceTemplate"></ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<!--STATIC BALANCE HEADER-->
<ng-template #balanceTemplate>
  <div class="tw-flex tw-items-center tw-w-full">
    <icon [size]="6" [name]="'dollar'" [currentColor]="'neutral-600'" class="bordered-icon"></icon>
    <span
      class="tw-ml-4 md:tw-ml-2 tw-text-lg tw-font-medium tw-uppercase tw-text-dt-text-secondary"
    >
      {{ 'balance' | i18n }}
    </span>
  </div>
</ng-template>

<!-- UPDATE BALANCE AUTOMATICALLY HEADER -->
<ng-template #updateBalanceAutomaticallyTemplate>
  <div
    class="tw-flex tw-items-center tw-h-10 tw-w-full tw-cursor-pointer"
    (click)="openPremiumDialog()"
  >
    <!-- Shiny diamond wrapper -->
    <div
      class="tw-relative tw-inline-block tw-w-12 tw-h-12 md:tw-w-10 md:tw-h-10 tw-mr-2 tw-overflow-hidden"
    >
      <!-- GLOW-EFFECT -->
      <ng-container [ngTemplateOutlet]="glowEffect"></ng-container>

      <!-- Diamond Icon -->
      <icon [size]="14" [name]="'diamond'" [currentColor]="'neutral-600'"></icon>

      <!-- Top-left Star -->
      <icon
        [size]="4"
        [name]="'single-star'"
        class="tw-absolute tw-top-1.5 tw-left-1.5 tw-animate-twinkle"
      ></icon>

      <!--Bottom-right Star-->
      <icon
        [size]="4"
        [name]="'single-star'"
        class="tw-absolute tw-bottom-1.5 tw-right-1.5 tw-animate-twinkle-delayed"
      ></icon>
    </div>

    <!-- UPDATE BALANCE AUTOMATICALLY HEADER TEXT -->
    <ng-container [ngTemplateOutlet]="autoBalanceText"></ng-container>
  </div>
</ng-template>

<!--GLOW EFFECT-->
<ng-template #glowEffect>
  <!-- Sharp soft glow - stronger, first sweep -->
  <div
    class="tw-absolute tw-top-1/2 tw-left-1/2 tw-w-24 tw-h-3 tw-bg-dt-surface-card/25 tw-animate-shine-sweep-1 tw-z-20"
    style="transform: translate(-50%, -50%)"
  ></div>

  <!-- Sharp bright line - subtler, shorter, second sweep -->
  <div
    class="tw-absolute tw-top-1/2 tw-left-1/2 tw-w-16 tw-h-2 tw-bg-dt-surface-card/40 tw-animate-shine-sweep-2 tw-z-30"
    style="transform: translate(-50%, -50%)"
  ></div>
</ng-template>

<!--UPDATE BALANCE AUTOMATICALLY-->
<ng-template #autoBalanceText>
  <div class="tw-flex tw-items-center tw-h-10 md:tw-h-5">
    <span
      class="tw-text-orange-550 tw-text-lg lg:tw-text-sm md:tw-text-xs tw-whitespace-nowrap tw-font-medium tw-uppercase tw-underline-offset-4 tw-underline"
    >
      {{ 'updateBalanceAutomatically' | i18n }}
    </span>

    <div class="tw-flex tw-items-center tw-h-10">
      <!-- Left Column (2 small stars) -->
      <div class="tw-flex tw-flex-col">
        <icon [size]="3" [name]="'single-star'"></icon>

        <icon [size]="3" [name]="'single-star'"></icon>
      </div>

      <!-- Right Column (1 large star) -->
      <div class="tw-flex tw-items-start">
        <icon [size]="6" [name]="'single-star'"></icon>
      </div>
    </div>
  </div>
</ng-template>
